import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ImageCms } from '~/cms/interfaces/homepage.cms.interface';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
})
export class PictureComponent implements OnInit {
  @Input() public image: ImageCms;
  @Input() public imageMobile: ImageCms;
  @Input() public isFullImage?: boolean;
  @Input() public position?: string;
  @Input() public classNamePicture?: string;
  @Input() public classNameImage?: string;
  @Input() public isHp?: boolean;

  public subscriptions: Subscription = new Subscription();
  public isMobileDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isTabletDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get imageDefault(): string {
    if (
      this.isHp &&
      this.isHp !== undefined &&
      this.image.formats?.large?.url !== ''
    ) {
      return this.image?.formats?.large?.url;
    } else if (
      this.isHp !== undefined &&
      !this.isHp &&
      this.image?.formats?.xlarge?.url !== ''
    ) {
      return this.image.formats?.xlarge?.url;
    }

    return this.image?.url;
  }

  public get imageLarge(): string {
    return this.position === 'left' || this.position === 'right'
      ? this.imageMedium
      : this.image?.formats?.large?.url;
  }

  public get imageMedium(): string {
    return this.image?.formats?.medium?.url;
  }

  public get imageSmall(): string {
    if (this.isFullImage) {
      if (this.imageMobile?.formats?.medium?.url) {
        return this.imageMobile?.formats?.medium?.url;
      } else if (this.imageMobile?.url) {
        return this.imageMobile?.url;
      }
    }

    if (this.imageMobile?.formats?.medium?.url) {
      return this.imageMobile?.formats?.medium?.url;
    } else if (this.imageMobile?.url) {
      return this.imageMobile?.url;
    } else {
      return this.image?.url;
    }
  }

  public get alternativeText(): string {
    return this.image?.alternativeText || '';
  }
}
